<template>
  <div>
    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Declarante
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="boxGenitor mb-4">
      <div class="boxGenitor_header p-2">
        <h3 class="boxGenitor_header_title">
          {{ arquivoEstruturado.nome }}
        </h3>
      </div>

      <div class="boxGenitor_body px-3 py-2">
        <div class="row no-gutters align-items-center">
          <div class="d-inline-flex boxGenitor_body_content">
            <div v-if="tipoRegistro === 'nascimento'" 
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Tipo de declarante
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('tipoDeclarante', arquivoEstruturado.tipo_declarante) }}</strong>
                </li>
              </ul>
            </div>
            
            <div class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  CPF
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('cpf', arquivoEstruturado.cpf) }}</strong>
                </li>
              </ul>
            </div>

            <div v-if="tipoRegistro === 'obito'" 
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  RG
                </li>

                <li class="boxGenitor_list_item">
                  <strong>
                    {{ arquivoEstruturado.documento_identificacao && arquivoEstruturado.documento_identificacao_orgao
                      ? `${arquivoEstruturado.documento_identificacao} (${arquivoEstruturado.documento_identificacao_orgao})`
                      : 'Não cadastrado'
                    }}
                  </strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Profissão
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ arquivoEstruturado.profissao || 'Não cadastrado' }}</strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Nacionalidade
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('nacionalidade', arquivoEstruturado.nacionalidade) }}</strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Estado Civil
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ arquivoEstruturado.estado_civil || 'Não cadastrado' }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Declarante',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      },
      tipoRegistro: {
        type: String,
        required: false,
        default: null
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (!dado) return 'Não cadastrado'
       
        switch (tipo) {
        case 'tipoDeclarante':
          return this.tratarTipoDeclarante(dado)

        case 'cpf':
          return this.formatarCpf(dado)

        case 'nacionalidade':
          return this.formatarTexto(dado)

        default:
          return dado
        }
      },
      tratarTipoDeclarante (dado) {
        const tipos = {
          mae: 'Mãe',
          pai: 'Pai'
        }

        return tipos[dado.toLowerCase()] || dado
      },
      formatarCpf (cpf) {
        cpf = cpf.toString().replace(/\D/g, '')

        if (cpf.length !== 11) return cpf

        return cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      },
      formatarTexto (texto) {
        return texto
          .toLowerCase()
          .replace(/\b\w/g, letra => letra.toUpperCase())
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;

    &_title {
      @extend %titleBox_title;
    }
  }
}
.boxGenitor {
  box-shadow: 0 0 pxToRem(4) 0 $color-dark;

  &_error {
    border: solid 2px #8B0000;
    border-radius: 2px;
  }

  &_header {
    background-color: #01AEC9;
    color: $color-dark;

    &_title {
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }

  &_body {
    &_content {}
  }

  &_list {
    font-size: pxToRem(14);
    list-style: none;
    margin: 0;
    padding: 0;

    &_item {}

    &_title {
      margin-bottom: pxToRem(4);
      text-decoration: underline;
    }
  }
}
</style>